import { css } from '@emotion/react'

const moreOptions = css`
  @media only screen and (max-height: 600px) {
    overflow: auto;
  }
`

const indentedStyle = css`
  margin-left: 40px;
`

const gapStyle = css`
  gap: 8px 0;
`

const rowWrapper = css`
  display: flex;
  flex: 1 1 100%;
`

export const styles = {
  indentedStyle,
  gapStyle,
  rowWrapper,
  moreOptions,
}
